import { createFileRoute } from '@tanstack/react-router';
import { CustomerMessagesPage } from '@/modules/customer-messages/pages/CustomerMessagesPage';

export const Route = createFileRoute('/dashboard/customer-messages/')({
  component: CustomerMessagesPage,
});
